import { PERMISSIONS } from '../../core/utils/permissions';
import { queryKeys } from '../../core/api/queryKeys';

export const SUBSCRIPTION_PERMISSIONS = {
  MANAGE: PERMISSIONS.SUBSCRIPTIONS,
};

export const SUBSCRIPTION_QUERY_KEYS = queryKeys.subscriptions;

export const SUBSCRIPTION_STATUSES = ['TRIALING', 'ACTIVE', 'PAST_DUE', 'CANCELLED'];

export const BILLING_CYCLES = ['MONTHLY', 'YEARLY'];

export const BILLING_SOURCES = ['SELF_SERVE', 'COMPLIMENTARY', 'PENDING_PROVIDER', 'MIGRATION'];

export const SUPPORT_LEVELS = ['EMAIL', 'CHAT', 'FULL_24_7'];

export const PLAN_CODES = ['STARTER', 'PROFESSIONAL', 'ENTERPRISE'];

export const SUBSCRIPTION_EVENT_TYPES = [
  'TRIAL_STARTED',
  'PLAN_CHANGED',
  'TRIAL_ELAPSED',
  'TRIAL_EXTENDED',
  'COMPLIMENTARY_GRANTED',
  'CANCELLED',
  'REACTIVATED',
];
